// @module C3.PDPSerialLotFunctionality.SerialLotData.InfoTooltip
//
// Shared helper for the info-icon (i) tooltips shown on the PDP and inside the
// "Select Serial Number" popup. Owns the description copy for each Functional /
// Cosmetic condition and knows how to (re)initialize Bootstrap tooltips on a
// jQuery root.
//
// Consumers:
//   - SerialLotData.View (main PDP)
//   - C3.PDPSerialLotFunctionality.SerialLotData.CarouselItems (popup dropdown row)
//   - C3.PDPSerialLotFunctionality.SerialLotData.PDView (popup right-hand pane)
//
// Contract: every info icon in the templates carries `rel="tooltip"`. Icons that
// should show a per-condition description also carry:
//   data-condition-group="functional" | "cosmetic"
//   data-current-label="{{currentLabelString}}"
// Icons without those attributes fall back to their inline `title=""` (used for
// the sale-price icon).

define('C3.PDPSerialLotFunctionality.SerialLotData.InfoTooltip'
,   ['jQuery']
, function (jQuery) {
    'use strict';

    // Keyed by the human-readable label shown next to the icon. If a label ever
    // gets renamed in SerialLotData.json, add/rename the key here too or the
    // tooltip goes blank silently.
    var CONDITION_TOOLTIPS = {
        functional: {
            'New':         'Brand new and unused. The item is in perfect working order and meets all original manufacturer specifications.',
            'Certified':   'Fully functional and quality-checked by our team. Meets AA Medical\u2019s certification standards for performance and reliability.',
            'Refurbished': 'Professionally restored to full working condition by trained technicians. Tested, cleaned, and verified to meet performance standards.'
        },
        cosmetic: {
            'Excellent': 'Looks brand new \u2014 no signs of wear or use. Clean, flawless appearance just like it came from the manufacturer.',
            'Good':      'Very minimal signs of previous use. The item looks great overall, with only light, hard-to-notice marks or wear.',
            'Fair':      'Shows moderate signs of use, such as small scratches or scuffs, but still looks clean and well cared for.',
            'Poor':      'Heavier cosmetic wear, including visible scratches, dents, or discoloration. Fully functional (if specified), but with noticeable aesthetic imperfections.'
        }
    };

    // Initialize Bootstrap tooltips on every [rel="tooltip"] element inside $root.
    // Safe to call on every render — Bootstrap tooltip binds jQuery data to the
    // element; when Backbone destroys the old DOM node it releases that data, so
    // repeated init on fresh elements does not leak.
    function initInfoTooltips($root) {
        if (!$root || !$root.find) { return; }

        // Clean up orphaned tooltip elements left in <body> from previous renders.
        // Because container:'body' places tooltips outside the view's $el, Backbone
        // re-renders leave them stranded and permanently visible.
        jQuery('body > .tooltip').remove();

        $root.find('[rel="tooltip"]').each(function () {
            var $el = jQuery(this);
            var group = $el.attr('data-condition-group');
            var $rich = $el.siblings('.tk-tooltip-content').first();

            $el.tooltip({
                container: 'body',
                html: true,
                trigger: 'hover focus',
                title: function () {
                    // 1. Dynamic per-condition mode — read current label from
                    //    the data-current-label attribute set at render time.
                    if (group && CONDITION_TOOLTIPS[group]) {
                        var label = ($el.attr('data-current-label') || '').trim();
                        return CONDITION_TOOLTIPS[group][label] || '';
                    }
                    // 2. Legacy full-legend mode — sibling HTML block.
                    if ($rich.length) {
                        return '<div class="tk-tooltip-inner">' + $rich.html() + '</div>';
                    }
                    // 3. Static one-liner from the element's title attribute
                    //    (Bootstrap moves it to data-original-title on init).
                    return $el.attr('data-original-title') || $el.attr('title') || '';
                }
            });
        });
    }

    return {
        initInfoTooltips: initInfoTooltips,
        // Exposed so callers can add/tweak copy without editing this file if needed.
        CONDITION_TOOLTIPS: CONDITION_TOOLTIPS
    };
});
